var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7962162,59.7342443 C51.1152739,57.6357944 61.8326942,43.5161147 59.7342443,28.197057 C57.6357944,12.8779993 43.5161147,2.16057907 28.197057,4.25902895 C12.8779993,6.35747883 2.16057907,20.4771585 4.25902895,35.7962162 C6.35747883,51.1152739 20.4771585,61.8326942 35.7962162,59.7342443 Z",
    id: "Oval",
    stroke: "#505050",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8,8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    fill: "#505050",
    fillRule: "nonzero",
    cx: 20,
    cy: 27,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7-Copy",
    fill: "#505050",
    fillRule: "nonzero",
    cx: 44,
    cy: 27,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,39.5 C24,41.5 28,42.5 32,42.5 C36,42.5 40,41.5 44,39.5",
    id: "Line-3",
    stroke: "#505050",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.494f727404b01faf2b3aa7c638a52650.svg";
export { ForwardRef as ReactComponent };